exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home {\n  padding: 5% 8%;\n}\n\n.landing-left {\n  width: 50%;\n}\n\n.landing-right {\n  width: 50%;\n}\n\n.six-rule-start {\n  margin-bottom: 100px;\n}\n", ""]);

// exports
